import { BaseModel } from '../../../../../../../core/_base/crud';
import { FileImport } from 'app/views/pages/nfc/dung-chung/__model/file-import.model';

export class PhieuKiemTra extends BaseModel {

    static category_path = "PKT";
    static DEFAULT_LOAIPHIEU = 1;
    static optionsTinhTrang: any = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'PKT_DANGSOANTHAO',
        },
        {
            id: 2,
            name: 'Chờ QA Lab nhập liệu',
            value: 'PKT_CHOXEMXET',
        },
        {
            id: 3,
            name: 'Không thông qua',
            value: 'PKT_KHONGTHONGQUA',
        },
        {
            id: 4,
            name: 'Chờ TP QA duyệt',
            value: 'PKT_CHODUYET',
        },
        {
            id: 5,
            name: 'Không duyệt',
            value: 'PKT_KHONGDUYET',
        },
        {
            id: 6,
            name: 'Đã duyệt',
            value: 'PKT_DADUYET',
        },
        {
            id: 7,
            name: 'Chờ SX ghi nhận',
            value: 'PKT_CHOGHINHAN_SX',
        },
        {
            id: 8,
            name: 'Chờ QA Process xem xét',
            value: 'PKT_CHOXEMXET_QA_B1',
        },
        {
            id: 9,
            name: 'Chờ QA Process xem xét',
            value: 'PKT_CHOXEMXET_QA_B2',
        },
        {
            id: 10,
            name: 'Chờ QA NL Ghi nhận',
            value: 'PKT_CHOGHINHAN_QA',
        },
    ];
    static optionsLoaiHang: any = [
        {
            id: 1,
            value: 1,
            name: 'Nguyên Liệu'
        },
        {
            id: 2,
            value: 2,
            name: 'Phụ Liệu'
        },
        {
            id: 3,
            value: 3,
            name: 'Hóa Chất'
        },
        {
            id: 4,
            value: 4,
            name: 'Thành Phẩm'
        },
        {
            id: 5,
            value: 5,
            name: 'Bán Thành Phẩm'
        },
        {
            id: 6,
            value: 6,
            name: 'Bao Bì'
        },
        {
            id: 7,
            value: 7,
            name: 'Văn Phòng Phẩm'
        },
        {
            id: 8,
            value: 8,
            name: 'Vật Tư'
        },
        {
            id: 9,
            value: 9,
            name: 'Tài Sản'
        },
        {
            id: 10,
            value: 10,
            name: 'Công Cụ Dụng Cụ'
        },
        {
            id: 11,
            value: 11,
            name: 'Trang Thiết Bị'
        },
        {
            id: 12,
            value: 12,
            name: 'Phụ Gia'
        },
        {
            id: 13,
            value: 13,
            name: 'Nhiên liệu'
        },
    ];
    static optionLoaiPhieu: any = [
        {
            id: 1,
            value: [1, 2, 3],
            name: 'nguyên phụ liệu - hóa chất'
        },
        {
            id: 2,
            value: [6],
            name: 'bao bì'
        },
        {
            id: 3,
            value: [4],
            name: 'thành phẩm'
        },
        {
            id: 4,
            value: [],
            name: 'khác'
        },
        {
            id: 5,
            value: [5],
            name: 'Bán thành phẩm'
        },
    ]

    Id: number
    Sophieu: string
    Loaiphieu: number
    Trangthai: string
    TenTrangThai: string
    HanghoaId: number
    MaHang: string
    TenHang: string
    IdLoai: number
    TenLoai: string
    QuyCach: string
    IdDVT: number
    TenDVT: string
    NccId: number
    MaNCC: string
    TenNCC: string
    KhachhangId: number
    TenKhachHang: string
    ThongtinhangveId: number
    IdLot: number
    Solosx: string
    Ngaysx: string
    Hansudung: string
    Hansudungtheothang: number
    Soluong: number
    SoluongDvt: number
    Ngaynhan: string
    Ngaysxlotruoc: string
    Thoigianbatdautiepnhan: string
    Thoigianketthuctiepnhan: string
    Ngaykiemtra: string
    Ngayphathanh: string
    Ghichu: string
    AttachmentId: number
    Quyetdinh: number
    Quyetdinhtext: string
    Chophepxuatkho: boolean
    Sodonvilaymau: string
    Soluongtra: number
    Soluongnhan: number
    SoluongtraNhanDvt: number
    Quyetdinhnhapkho: number
    Xulyphatsinhkph: boolean
    Thoigiantao: string
    Nguoitao: number
    TenNguoiTao: string
    Thoigiansua: string
    Nguoisua: number
    IdNKCT: number
    IdNk: number
    SoPhieuNK: string
    isDuyet: boolean
    lyDoDuyet: string
    listPhieuKiemTraKetQua: PhieuKiemTraKetQua[]
    listPhieuKiemTraLsThaoTac: PhieuKiemTraLsThaoTac[]
    listFileDinhKem: FileImport[]

    PhuHop_KhoiLuong: number
    PhuHop_Kho: number
    PhuHop_TinhTrangXuat: boolean
    PhuHop_LyDoKhongDuocXuat: string
    KPH_KhoiLuong: number
    KPH_Kho: number
    KPH_TinhTrangXuat: boolean
    KHP_LyDoKhongDuocXuat: string
    Tra_KhoiLuong: number
    Tru_KhoiLuong: number

    isNLK: boolean
    isNLT: boolean

    isCreateKPH: boolean

    clear() {
        this.Id = 0;
        this.Sophieu = '';
        this.Loaiphieu = 0;
        this.Trangthai = '';
        this.TenTrangThai = '';
        this.HanghoaId = 0;
        this.MaHang = '';
        this.TenHang = '';
        this.IdLoai = 0;
        this.TenLoai = '';
        this.QuyCach = '';
        this.IdDVT = 0;
        this.TenDVT = '';
        this.NccId = 0;
        this.MaNCC = '';
        this.TenNCC = '';
        this.KhachhangId = 0;
        this.TenKhachHang = '';
        this.ThongtinhangveId = 0;
        this.IdLot = 0;
        this.Solosx = '';
        this.Ngaysx = '';
        this.Hansudung = '';
        this.Hansudungtheothang = 0;
        this.Soluong = 0;
        this.SoluongDvt = 0;
        this.Ngaynhan = '';
        this.Ngaysxlotruoc = '';
        this.Thoigianbatdautiepnhan = '';
        this.Thoigianketthuctiepnhan = '';
        this.Ngaykiemtra = '';
        this.Ngayphathanh = '';
        this.Ghichu = '';
        this.AttachmentId = 0;
        this.Quyetdinh = 0;
        this.Quyetdinhtext = '';
        this.Chophepxuatkho = false;
        this.Sodonvilaymau = '';
        this.Soluongtra = 0;
        this.Soluongnhan = 0;
        this.SoluongtraNhanDvt = 0;
        this.Quyetdinhnhapkho = 0;
        this.Xulyphatsinhkph = false;
        this.Thoigiantao = '';
        this.Nguoitao = 0;
        this.TenNguoiTao = '';
        this.Thoigiansua = '';
        this.Nguoisua = 0;
        this.IdNKCT = 0;
        this.IdNk = 0;
        this.SoPhieuNK = '';
        this.isDuyet = false;
        this.lyDoDuyet = '';
        this.listPhieuKiemTraKetQua = [];
        this.listPhieuKiemTraLsThaoTac = [];
        this.listFileDinhKem = [];

        this.PhuHop_KhoiLuong = 0;
        this.PhuHop_Kho = 0;
        this.PhuHop_TinhTrangXuat = false;
        this.PhuHop_LyDoKhongDuocXuat = "";
        this.KPH_KhoiLuong = 0;
        this.KPH_Kho = 0;
        this.KPH_TinhTrangXuat = false;
        this.KHP_LyDoKhongDuocXuat = "";
        this.Tra_KhoiLuong = 0;
        this.Tru_KhoiLuong = 0;

        this.isNLK = false;
        this.isNLT = false;
        
        this.isCreateKPH = true;
    }
    copy(item: PhieuKiemTra) {
        this.Id = item.Id;
        this.Sophieu = item.Sophieu;
        this.Loaiphieu = item.Loaiphieu;
        this.Trangthai = item.Trangthai;
        this.TenTrangThai = item.TenTrangThai;
        this.HanghoaId = item.HanghoaId;
        this.MaHang = item.MaHang;
        this.TenHang = item.TenHang;
        this.IdLoai = item.IdLoai;
        this.TenLoai = item.TenLoai;
        this.QuyCach = item.QuyCach;
        this.IdDVT = item.IdDVT;
        this.TenDVT = item.TenDVT;
        this.NccId = item.NccId;
        this.MaNCC = item.MaNCC;
        this.TenNCC = item.TenNCC;
        this.KhachhangId = item.KhachhangId;
        this.TenKhachHang = item.TenKhachHang;
        this.ThongtinhangveId = item.ThongtinhangveId;
        this.IdLot = item.IdLot;
        this.Solosx = item.Solosx;
        this.Ngaysx = item.Ngaysx;
        this.Hansudung = item.Hansudung;
        this.Hansudungtheothang = item.Hansudungtheothang;
        this.Soluong = item.Soluong;
        this.SoluongDvt = item.SoluongDvt;
        this.Ngaynhan = item.Ngaynhan;
        this.Ngaysxlotruoc = item.Ngaysxlotruoc;
        this.Thoigianbatdautiepnhan = item.Thoigianbatdautiepnhan;
        this.Thoigianketthuctiepnhan = item.Thoigianketthuctiepnhan;
        this.Ngaykiemtra = item.Ngaykiemtra;
        this.Ngayphathanh = item.Ngayphathanh;
        this.Ghichu = item.Ghichu;
        this.AttachmentId = item.AttachmentId;
        this.Quyetdinh = item.Quyetdinh;
        this.Quyetdinhtext = item.Quyetdinhtext;
        this.Chophepxuatkho = item.Chophepxuatkho;
        this.Sodonvilaymau = item.Sodonvilaymau;
        this.Soluongtra = item.Soluongtra;
        this.Soluongnhan = item.Soluongnhan;
        this.SoluongtraNhanDvt = item.SoluongtraNhanDvt;
        this.Quyetdinhnhapkho = item.Quyetdinhnhapkho;
        this.Xulyphatsinhkph = item.Xulyphatsinhkph;
        this.Thoigiantao = item.Thoigiantao;
        this.Nguoitao = item.Nguoitao;
        this.TenNguoiTao = item.TenNguoiTao;
        this.Thoigiansua = item.Thoigiansua;
        this.Nguoisua = item.Nguoisua;
        this.IdNKCT = item.IdNKCT;
        this.IdNk = item.IdNk;
        this.SoPhieuNK = item.SoPhieuNK;
        this.isDuyet = item.isDuyet;
        this.lyDoDuyet = item.lyDoDuyet;
        this.listPhieuKiemTraKetQua = item.listPhieuKiemTraKetQua;
        this.listPhieuKiemTraLsThaoTac = item.listPhieuKiemTraLsThaoTac;
        this.listFileDinhKem = item.listFileDinhKem;

        this.PhuHop_KhoiLuong = item.PhuHop_KhoiLuong;
        this.PhuHop_Kho = item.PhuHop_Kho;;
        this.PhuHop_TinhTrangXuat = item.PhuHop_TinhTrangXuat;
        this.PhuHop_LyDoKhongDuocXuat = item.PhuHop_LyDoKhongDuocXuat;
        this.KPH_KhoiLuong = item.KPH_KhoiLuong;
        this.KPH_Kho = item.KPH_Kho;
        this.KPH_TinhTrangXuat = item.KPH_TinhTrangXuat;
        this.KHP_LyDoKhongDuocXuat = item.KHP_LyDoKhongDuocXuat;
        this.Tra_KhoiLuong = item.Tra_KhoiLuong;
        this.Tru_KhoiLuong = item.Tru_KhoiLuong;

        this.isNLK = item.isNLK;
        this.isNLT = item.isNLT;
        
        this.isCreateKPH = item.isCreateKPH;
    }
}
export class PhieuKiemTraKetQua extends BaseModel {
    Id: number
    PhieukiemtraId: number
    MauphieukiemtraId: number
    MauphieukiemtraIdNhom: number
    MauphieukiemtraChitieuId: number
    TenNhomChiTieu: string
    TenChiTieu: string
    TieuChuan: string
    SoTieuChiTrongNhom: number
    Ketqua: string
    Danhgiaketqua: boolean
    TmpDanhgiaketqua: number
    Diengiai: string
    Thoigiandutru: string
    Danhgiaketquaselect: number
    isDisable: boolean
    BoPhanNhapLieu: number
    khongdanhgiaketqua: boolean
    textdanhgiaketqua: string

    clear() {
        this.Id = 0;
        this.PhieukiemtraId = 0;
        this.MauphieukiemtraId = 0;
        this.MauphieukiemtraIdNhom = 0;
        this.MauphieukiemtraChitieuId = 0;
        this.TenNhomChiTieu = '';
        this.TenChiTieu = '';
        this.TieuChuan = '';
        this.SoTieuChiTrongNhom = 0;
        this.Ketqua = '';
        this.Danhgiaketqua = null;
        this.TmpDanhgiaketqua = -1;
        this.Diengiai = '';
        this.Thoigiandutru = '';
        this.Danhgiaketquaselect = 0;
        this.isDisable = false;
        this.BoPhanNhapLieu = -1;
        this.khongdanhgiaketqua = false;
        this.textdanhgiaketqua = '';
    }

    copy(item: PhieuKiemTraKetQua) {
        this.Id = item.Id;
        this.PhieukiemtraId = item.PhieukiemtraId;
        this.MauphieukiemtraId = item.MauphieukiemtraId;
        this.MauphieukiemtraIdNhom = item.MauphieukiemtraIdNhom;
        this.MauphieukiemtraChitieuId = item.MauphieukiemtraChitieuId;
        this.TenNhomChiTieu = item.TenNhomChiTieu;
        this.TenChiTieu = item.TenChiTieu;
        this.TieuChuan = item.TieuChuan;
        this.SoTieuChiTrongNhom = item.SoTieuChiTrongNhom;
        this.Ketqua = item.Ketqua;
        this.Danhgiaketqua = item.Danhgiaketqua;
        this.TmpDanhgiaketqua = item.TmpDanhgiaketqua;
        this.Diengiai = item.Diengiai;
        this.Thoigiandutru = item.Thoigiandutru;
        this.Danhgiaketquaselect = item.Danhgiaketquaselect;
        this.BoPhanNhapLieu = item.BoPhanNhapLieu;
        this.khongdanhgiaketqua = item.khongdanhgiaketqua;
        this.textdanhgiaketqua = item.textdanhgiaketqua;
    }
}
export class PhieuKiemTraLsThaoTac extends BaseModel {
    Id: number;
    PhieudenghiId: number;
    Nguoithaotac: number;
    TenNguoiThaoTac: string;
    Ngaythaotac: string;
    Loaithaotac: string;
    Noidung: string;
    Ghichu: string;

    clear() {
        this.Id = 0;
        this.PhieudenghiId = 0;
        this.Nguoithaotac = 0;
        this.TenNguoiThaoTac = '';
        this.Ngaythaotac = '';
        this.Loaithaotac = '';
        this.Noidung = '';
        this.Ghichu = '';
    }

    copy(item: PhieuKiemTraLsThaoTac) {
        this.Id = item.Id;
        this.PhieudenghiId = item.PhieudenghiId;
        this.Nguoithaotac = item.Nguoithaotac;
        this.TenNguoiThaoTac = item.TenNguoiThaoTac;
        this.Ngaythaotac = item.Ngaythaotac;
        this.Loaithaotac = item.Loaithaotac;
        this.Noidung = item.Noidung;
        this.Ghichu = item.Ghichu;
    }
}